


































































































































































































import { Utils } from '@/helper/utils';
import { Component } from 'vue-property-decorator';
import { Base } from './base';

@Component({
  props: [
    'url',
    'customerKey',
    'vin',
    'amount',
    'totalAmount',
    'invoiceNumber',
    'tenantId',
    'enterpriseId',
    'storeId',
    'dealId',
    'storeName',
    'address',
    'zipcode',
    'city',
    'state',
    'phoneNumber',
    'firstName',
    'lastName',
    'comments',
    'transactionHeaderId',
    'lastPaymentDetailId',
    'loggedInUserId',
    'loggedInUserEmail',
    'customerEmail',
    'merchantEmail',
    'recordKey',
    'recordIdentifier',
    'type',
    'cenposDialog',
    'showTextField',
    'other',
    'selectedCharges',
    'name',
    'account',
    'control',
    'reference',
    'description',
    'lineItems',
    'isAmountOverride',
    'isDeductiblePayment',
    'isSendPaymentReceipt'
  ],
})
export default class CenposPayment extends Base {
  public cenposUrl: string = Utils.WEB_BASE_URL + '/serverpay/cenpos';

  public close() {
    this.$emit('cenposDialog', false);
  }
}
